const VITE_SERVER_URL = import.meta.env.VITE_SERVER_URL;

export const LOGIN_URL = `${VITE_SERVER_URL}/operator/login?redirect_uri=${window.location.origin}/oauth-callback`;
export const LOGOUT_URL = `${VITE_SERVER_URL}/operator/logout?redirect_uri=${window.location.href}`;
export const REISSUE_TOKEN_URL = '/operator/access-token/reissue';
